import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { buildWhatsappLink } from "@/lib/constants";

const FinalCTA = () => {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="bg-[#0a0a0a] py-24 md:py-36 relative overflow-hidden"
    >
      <div
        className="absolute top-10 left-8 w-12 h-12 bg-white brutal-border vc-float hidden md:block"
        style={{ "--rot": "10deg" }}
      />
      <div
        className="absolute bottom-16 right-12 w-16 h-16 bg-[#ff6b35] brutal-border-thick rotate-12 vc-float hidden md:block"
        style={{ animationDelay: "1s" }}
      />
      <div
        className="absolute top-1/3 right-1/4 vc-float hidden lg:block"
        style={{ animationDelay: "1.6s" }}
      >
        <div
          className="w-0 h-0"
          style={{
            borderLeft: "26px solid transparent",
            borderRight: "26px solid transparent",
            borderBottom: "44px solid #ffffff",
          }}
        />
      </div>

      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 text-center relative">
        <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-6 vc-reveal">
          Próximo passo
        </div>
        <h2 className="font-display text-[#ff6b35] text-[2.4rem] min-[380px]:text-5xl sm:text-7xl md:text-8xl uppercase leading-[0.92] vc-reveal">
          Conte-nos o problema <br />
          <span className="text-white">receba uma solução.</span>
        </h2>
        <p className="text-white/80 text-base sm:text-xl mt-8 max-w-2xl mx-auto vc-reveal">
          Fale conosco sobre websites, sistemas, automações, IA ou suporte
          tecnológico recorrente. Respondemos com o caminho mais simples para
          resolver o problema da sua empresa.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center justify-center gap-4 sm:gap-5">
          <Link
            data-testid="final-cta-button"
            to="/contacto"
            className="btn-brutal btn-brutal-orange text-sm sm:text-base justify-center text-center"
          >
            Conte-nos o problema <ArrowRight size={20} className="shrink-0" />
          </Link>
          <a
            href={buildWhatsappLink(
              "Olá! Quero contar um problema da minha empresa e perceber que solução tecnológica faz sentido.",
              "final_problem"
            )}
            target="_blank"
            rel="noreferrer"
            className="btn-brutal text-sm sm:text-base justify-center text-center"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
